var wangeditor = require('wangeditor')
var vueWangeditor = require('./vueWangeditor')

module.exports = vueWangeditor

// import wangeditor from 'wangeditor'
// import vueWangeditor from './vueWangeditor'

// export default vueWangeditor
